// lazy image
import 'react-lazy-load-image-component/src/effects/blur.css';
import 'react-lazy-load-image-component/src/effects/opacity.css';
import 'react-lazy-load-image-component/src/effects/black-and-white.css';

import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { Provider as ReduxProvider } from 'react-redux';
import { PersistGate } from 'redux-persist/lib/integration/react'; // TODO нужно?
import { store, persistor } from './storage'; // TODO persistor нужно?
import { SettingsProvider } from './hooks/_contexts/SettingsContext';
import { CollapseDrawerProvider } from './hooks/_contexts/CollapseDrawerContext';
import App from './App';
import { DebugContextProvider } from 'hooks/_contexts/DebugContext';
import { createRoot } from 'react-dom/client';

// ----------------------------------------------------------------------

const container = document.getElementById('root');
const root = createRoot(container!);
root.render(
  <HelmetProvider>
    <DebugContextProvider>
      <ReduxProvider store={store}>
        <PersistGate persistor={persistor}>
          <SettingsProvider>
            <CollapseDrawerProvider>
              <BrowserRouter>
                <App />
              </BrowserRouter>
            </CollapseDrawerProvider>
          </SettingsProvider>
        </PersistGate>
      </ReduxProvider>
    </DebugContextProvider>
  </HelmetProvider>
);
